import util from '@bmp-vue/core/api/util'

let controller = 'Subparceiro'
export default Object.assign({}, util.GetCrud(controller, null), {
    ListarSubparceiros: function (dto) {
        return util.Axios.Get(controller , dto)
      },
})
